// bao migrate skip
import "./../services/bao-menu";
import "./../services/bao-router";
import "./../services/finito-service";
import "./../services/bao-shouter";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import Guid from "./../factories/guid";
import BaoDialog from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import baoRouter from "./../services/bao-router";
import finitoService from "./../services/finito-service";
import baoShouter from "./../services/bao-shouter";
import SubscriptionViewModel from "../factories/subscription-view-model";
class WhiteboardBookViewModel extends SubscriptionViewModel {
    private _subs: KnockoutSubscription[] = [];
    Whiteboards: KnockoutObservableArray<any> = ko.observableArray([]);
    SelectedWhiteboardId: KnockoutObservable<string> = ko.observable();
    Models: KnockoutObservableArray<any> = ko.observableArray([]);
    ShiftbooksPermissions: any
    SettingsUrl: KnockoutObservable<string> = ko.observable(null);
    SettingsKeyPermission: KnockoutObservable<string> = ko.observable(null);
    SettingsKeyPermissionApplicationId: KnockoutObservable<string> = ko.observable(null);
    constructor(tabPage) {
        super(tabPage);

        this.SettingsKeyPermission("ShiftbookSave");
        this.SettingsKeyPermissionApplicationId(window.FinitoApplicationId);
        this.TabPage = tabPage;
        this.SelectedWhiteboardId.subscribe(() => {
            this.RefreshWhiteboardEntries();
            this.isQuickStartModuleActive();
            baoRouter.setHash("whiteboardbook/" + this.SelectedWhiteboardId());
            this.SettingsUrl(this.SelectedWhiteboardId() ? 'Shiftbook/' + this.SelectedWhiteboardId() : null);
            
        });
        this.TotalRows.subscribe(() => {
            this.toggleButtons();
        });
        this.Models.subscribe(() => {
            this.LoadImageAttachments();
        });
        this.subscribe(this.TabPage.UrlData, (value) => {
            if (value.whiteboardid && this.SelectedWhiteboardId() != value.whiteboardid && this.Whiteboards().some(b => ko.unwrap(b.ShiftbookId) == value.whiteboardid)) {
                this.SelectedWhiteboardId(value.whiteboardid)
            }
        });

    }
    TabPage;
    ShowListView: KnockoutObservable<boolean> = ko.observable<boolean>(true);
    ShowDeletedWhiteboardEntries = ko.observable<boolean>(false);
    ShowInvalidWhiteboardEntries = ko.observable<boolean>(false);
    PageSize = ko.observable<number>(20);
    PageIndex = ko.observable<number>(0);
    TotalRows = ko.observable<number>(0);
    Sorting = ko.observableArray();
    CustomFilter = ko.observable({});
    Selection = ko.observableArray<{
        InstructionId: KnockoutObservable<string>;
    }>([]);
    IsFavorite: KnockoutObservable<boolean> = ko.observable(false);
    Color: string = "text-primary";
    Icon: string = "fal fa-info";
    Sort: number = 40;

    public SetShowListViewFalse = () => {
        this.SetShowListView(false);
    }

    public SetShowListViewTrue = () => {
        this.SetShowListView(true);
    }

    public SetShowListView = (value: boolean) => {
        this.ShowListView(value);
    }

    public LoadImageAttachments = () => {
        this.Models().forEach(Model => {
            Model.ImageAttachments = ko.observableArray([]);
            Model.Attachments = ko.observableArray([]);

            Model.InstructionAttachment().forEach(Attachment => {
                if (this.IsImageFileName(Attachment.Description())) {
                    return Bao.post("Whiteboard/GetAttachment", JSON.stringify({ InstructionAttachmentId: Attachment.InstructionAttachmentId() }), (AttachmentBinary) => {
                        Model.ImageAttachments.push(this.CreateImageAttachment(AttachmentBinary));
                    });
                }
                else {
                    Model.Attachments.push(Attachment);
                }
            })
        })
    }

    public CreateImageAttachment = function (data) {
        let newAttachment = {
            Attachment: ko.observable("data:image/png;base64," + data.Attachment),
            FileName: ko.observable(data.FileName),
        }

        return newAttachment;
    }

    public IsImageFileName(FileName) {
        let fileType: string = FileName.substr(FileName.length - 4).toLowerCase();

        if (fileType == '.jpg' || fileType == '.png' || fileType == '.jpeg ') {
            return true;
        }
        else {
            return false;
        }
    }

    /**
     * wird benutzt um die action-keys auszuwerten
     */
    FormName = ko.observable<string>("WhiteboardReport");
    link(index: number, whiteboardModel) {
        var linkHash = 'whiteboard/' + whiteboardModel.InstructionId();
        baoRouter.setHash(linkHash);
    }
    registerMenuClick() {
        BaoMenu.registerEvent((btn) => {
            if (this.TabPage != null && this.TabPage.IsActiveTab != null && this.TabPage.IsActiveTab() === true) {
                var methodString = btn.ActionKey().substr(this.FormName().length);
                if (methodString) {
                    methodString = methodString.toLowerCase();
                    if ($.isFunction(this[methodString])) {
                        this[methodString]();
                    }
                }
            }
        });
    }
    getWhiteboards = () => {
        return Bao.post('Shiftbook/GetWhiteboardsForCurrentUser').then(serverResult => {
            let whiteboardId = baoRouter.getRouteValue("whiteboardid", this.TabPage);
            if (whiteboardId) {
                whiteboardId = whiteboardId.toLowerCase();
                if (serverResult.BooksForCurrentUser.filter(t => t.ShiftbookId === whiteboardId).length > 0) {
                    this.SelectedWhiteboardId(whiteboardId);
                }
            }
            //if (whiteboards.length > 0) {
            if (serverResult && serverResult.BooksForCurrentUser && serverResult.BooksForCurrentUser.length > 0) {
                this.ShiftbooksPermissions = serverResult.ShiftbooksPermissions;
                this.Whiteboards(serverResult.BooksForCurrentUser);
            }
            else {
                new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgUserHasNoAssignedWhiteboards"), "info");
                this.TabPage.IsLoading(false);
            }
        });
    };
    RefreshWhiteboardEntries() {
        this.TabPage.IsLoading(true);
        this.getWhiteboardEntries()
            .always(() => {
            this.TabPage.IsLoading(false);
        });
    }
    getWhiteboardEntries() {
        if (!this.SelectedWhiteboardId())
            return;
        var customFilter = this.ToHashObject(ko.unwrap(this.CustomFilter));
        return Bao.post('WhiteboardBook/GetAll', JSON.stringify({
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: this.Sorting(),
            searchFilter: {
                ShowDeleted: this.ShowDeletedWhiteboardEntries(),
                ShowInvalid: this.ShowInvalidWhiteboardEntries(),
                ShiftbookIds: [this.SelectedWhiteboardId()]
            },
            customfilter: customFilter
        })).then((result) => {
            ko.map.fromJS(result.Models, this.Models);
            this.TotalRows(result.TotalRows);
        });
    }

    formatAreaStructure(AreaName, Equipment) {
        let areaScturucteFormatted = AreaName();

        if (Equipment() != null && Equipment() != "") {
            areaScturucteFormatted = areaScturucteFormatted + " / " + Equipment();
        }

        return areaScturucteFormatted;
    }

    toggleButtons() {
        if (this.FormName) {
            if (this.SelectedWhiteboardId()) {
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'New', Enabled: true, Context: this.TabPage.Context() });
            }
            else {
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'New', Enabled: false, Context: this.TabPage.Context() });
            }
            if (this.TotalRows && this.TotalRows() < 1) {
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Edit', Enabled: false, Context: this.TabPage.Context() });
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Delete', Enabled: false, Context: this.TabPage.Context() });
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Print', Enabled: false, Context: this.TabPage.Context() });
            }
            else {
                var selection = this.Selection.peek();
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Print', Enabled: true, Context: this.TabPage.Context() });
                if (selection && selection.length > 0) {
                    BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Edit', Enabled: true, Context: this.TabPage.Context() });
                    BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Delete', Enabled: true, Context: this.TabPage.Context() });
                }
                else {
                    BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Edit', Enabled: false, Context: this.TabPage.Context() });
                    BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Delete', Enabled: false, Context: this.TabPage.Context() });
                }
            }
        }
    }
    new() {
        var linkHash = 'whiteboard/' + Guid() + '/' + this.SelectedWhiteboardId();
        baoRouter.setHash(linkHash);
    }
    edit() {
        var selection = this.Selection();
        if (selection && selection.length > 0) {
            baoRouter.setHash('whiteboard/' + selection[0].InstructionId());
        }
    }
    delete() {
        if (this.Selection() && this.Selection().length > 0) {
            var dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.WhiteboardDeleteQuestion), 'yesno');
            dialog.DialogResult.subscribe((canDelete) => {
                if (canDelete) {
                    this.TabPage.IsLoading(true);
                    return Bao.post('Whiteboard/Delete', JSON.stringify({
                        instructionIds: [this.Selection()[0].InstructionId()]
                    })).then((deleted) => {
                        this.Selection([]);
                        if (deleted > 0) {
                            this.showAlert(finitoService.MessageKeys.WhiteboardDeleteSuccessful);
                            this.refresh();
                        }
                        else {
                            this.showAlert(finitoService.MessageKeys.WhiteboardDeleteError, 'danger');
                        }
                        this.TabPage.IsLoading(false);
                    });
                }
            });
        }
    }
    refresh() {
        this.RefreshWhiteboardEntries();
    }
    ;
    print() {
        //window.open('WhiteboardBook/Print?' + $.param({ showDeleted: this.ShowDeletedWhiteboardEntries() }));
        this.TabPage.IsLoading(true);
        Bao.post("WhiteboardBook/Print", JSON.stringify({
            showDeleted: this.ShowDeletedWhiteboardEntries(),
            shiftbookId: this.SelectedWhiteboardId()
        }), (result) => {
            this.TabPage.IsLoading(false);
            if (result.Result == true) {
                baoRouter.setHash("document/" + result.Message);
            }
            else {
                // BaoDialogViewModel(Bao.Session.GetApplicationName(), result.Message, "info");
            }
        });
    }
    ;
    showAlert(messageKey: string, type?: string) {
        if (!type) {
            type = 'success';
        }
        var message = Bao.Session.GetMessage(messageKey);
        // HACK: show shouter if message is loaded ... ( boa extension is planned to get better code ... )
        if (message() !== "") {
            baoShouter.show(message(), type);
        }
        else {
            var sub = message.subscribe(function (msg) {
                baoShouter.show(msg, type);
                sub.dispose();
            });
        }
    }
    ;
    private getWhiteBoardModel() {
        return Bao.post("WhiteboardBook/GetModel", JSON.stringify({}))
            .done((data) => {
            this.TabPage.Title(data.TabName);
        });
    }
    public init() {
        this.TabPage.IsLoading(true);
        return this.getWhiteboards()
            .then(() => {
            return this.getWhiteBoardModel();
        });
    }
    public loaded() {
        var def = $.Deferred();
        this.registerMenuClick();
        this.toggleButtons();
        this.SetPermissions();
        Bao.bindEvent('whiteboardEntries:refresh', (value) => {
            // TODO nice to have, check if value affects whiteboard
            this.refresh();
        });
        Bao.bindEvent('FavoriteIcon:refresh', (value) => {
            this.IsFavorite(!this.IsFavorite());
        });
        this._subs.push(this.Selection.subscribe((newVal) => {
            this.toggleButtons();
        }));
        this._subs.push(this.Sorting.subscribe((newVal) => {
            this.RefreshWhiteboardEntries();
        }));
        this._subs.push(this.CustomFilter.subscribe((newVal) => {
            this.ResetPageIndexAndRefresh();
        }));
        this._subs.push(this.ShowDeletedWhiteboardEntries.subscribe((newVal) => {
            this.ResetPageIndexAndRefresh();
        }));
        this._subs.push(this.ShowInvalidWhiteboardEntries.subscribe((newVal) => {
            this.ResetPageIndexAndRefresh();
        }));
        this._subs.push(this.PageIndex.subscribe((newVal) => {
            this.RefreshWhiteboardEntries();
        }));
        this._subs.push(this.PageSize.subscribe((newVal) => {
            this.ResetPageIndexAndRefresh();
        }));
        
        def.resolve();
        return def.promise();
    }
    public ToHashObject(customFilter) {
        var returnValue = [];
        for (var f in customFilter) {
            returnValue.push({ Key: f, Value: ko.unwrap(customFilter[f]) });
        }
        return returnValue;
    }
    ;
    /**
     * Get the permissions object for the current selected instructionbook
     * */
    GetCurrentBooksPermissions() {
        if (this.SelectedWhiteboardId() && this.ShiftbooksPermissions) {
            return this.ShiftbooksPermissions[this.SelectedWhiteboardId()];
        }
        return null;
    }
    /**
     * Shows/Hides toolbarbuttons for the current taskbookpermissions (RoleShiftbooks)
     * */
    SetPermissions() {
        let permissions = this.GetCurrentBooksPermissions();
        if (!permissions)
            return;
        for (let actionKey in permissions) {
            BaoMenu.permissionVisible({ ActionKey: actionKey, Context: this.TabPage.Context(), Visible: permissions[actionKey] });
        }
    }
    ResetPageIndexAndRefresh() {
        if (this.PageIndex() === 0) {
            this.RefreshWhiteboardEntries();
        }
        else {
            this.PageIndex(0);
        }
    }
    ;
    changeFavoriteStatus = () => {
        var promise;
        if (this.IsFavorite()) {
            promise = this.removeQuickStartModuleWebUrl();
        }
        else {
            promise = this.addQuickStartModule();
        }
        promise.then(() => { Bao.raiseEvent('QuickStartModules:refresh', null); });
    };
    addQuickStartModule = () => {
        this.TabPage.IsLoading(true);
        var selectedWhitheBoardBook = this.Whiteboards().
            filter(e => e.PrimaryKeyValue === this.SelectedWhiteboardId());
        var WhiteboardName = selectedWhitheBoardBook[0].Name;
        var WhiteboardCssClass = selectedWhitheBoardBook[0].CssClass;
        return Bao.post("StartModule/AddQuickStartModule", JSON.stringify({
            caption1: WhiteboardName,
            caption2: WhiteboardName,
            caption3: WhiteboardName,
            caption4: WhiteboardName,
            caption5: WhiteboardName,
            webUrl: this.GetWhiteBoardBookDeepLink(),
            color: this.Color,
            icon: (typeof WhiteboardCssClass != 'undefined' && WhiteboardCssClass) ? WhiteboardCssClass : this.Icon,
            sort: this.Sort
        })).done(result => {
            if (result) {
                this.IsFavorite(true);
            }
            this.TabPage.IsLoading(false);
        });
    };
    isQuickStartModuleActive = () => {
        return Bao.post("StartModule/IsQuickStartModuleActive", JSON.stringify({
            webUrl: this.GetWhiteBoardBookDeepLink()
        })).done(result => {
            this.IsFavorite(result);
        });
    };
    removeQuickStartModuleWebUrl = () => {
        this.TabPage.IsLoading(true);
        return Bao.post("StartModule/RemoveQuickStartModuleByWebUrl", JSON.stringify({
            webUrl: this.GetWhiteBoardBookDeepLink()
        })).done(result => {
            if (result) {
                this.IsFavorite(false);
            }
            this.TabPage.IsLoading(false);
        });
    };
    GetWhiteBoardBookDeepLink() {
        return "#/whiteboardbook/" + this.SelectedWhiteboardId();
    }
}
export default WhiteboardBookViewModel;